import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useCurrentUser } from "@/hooks/useCurrentUser";
import type { Concept } from "@/types/concept";

/** Ring users can't use a concept whose guided setup is unfinished: send them
 *  back to it. `=== null` on purpose — undefined means a pre-1b backend. */
export function useSetupRedirect(concept: Concept | undefined) {
  const navigate = useNavigate();
  const { data: me } = useCurrentUser();
  const unfinished = !!me?.features?.setup_v2 && concept?.setup_completed_at === null;
  useEffect(() => {
    if (unfinished && concept) navigate({ to: "/concepts/new", search: { resume: concept.id }, replace: true });
  }, [unfinished, concept, navigate]);
}
